import { app } from "@microsoft/teams-js";
import { ScheduleDTO } from "@teams/types/api";
import { useCallback, useState } from "react";

import { FetchResult, isSuccess } from "../../_shared/services/ChannelApi";
import { scheduleApi } from "../../_shared/services/ScheduleApi";
import { ContentScope } from "./useChannelSurveys";

type LoadSchedulesOptions = {
  includeResponses?: boolean;
};
export const useChannelSchedules = () => {
  const [isSchedulesLoading, setIsSchedulesLoading] = useState<boolean>(true);
  const [schedules, setSchedules] = useState<ScheduleDTO[]>([]);
  const [schedulesError, setSchedulesError] = useState<Error>();

  const loadSchedules = useCallback(
    async (context: app.Context, scope: ContentScope, options?: LoadSchedulesOptions) => {
      setIsSchedulesLoading(true);
      setSchedulesError(undefined);

      let schedulesResponse: FetchResult<ScheduleDTO[]> = [];
      if (scope === "team") {
        schedulesResponse = await scheduleApi.audienceSchedules(context, {
          ...options,
        });
      } else if (scope === "personal") {
        schedulesResponse = await scheduleApi.userSchedulesByAudience(context, {
          ...options,
        });
      } else if (scope === "tenant") {
        schedulesResponse = await scheduleApi.userSchedules(context, {
          ...options,
        });
      }

      if (isSuccess(schedulesResponse)) {
        setSchedules(
          schedulesResponse.sort((a, b) => b.updatedAt.getTime() - a.updatedAt.getTime())
        );
      } else {
        setSchedulesError(schedulesResponse);
      }

      setIsSchedulesLoading(false);
    },
    []
  );

  return { schedulesError, loadSchedules, isSchedulesLoading, schedules, setSchedules };
};
